
const isStringNumber = (number: string): boolean => {
    try {
        let result = parseInt(number);
        return !Number.isNaN(result) ? true : false;
    }
    catch (error) {
        return false;
    }
}

const typeHelper = {
    isString: (x: any): boolean => typeof x === 'string',
    isFunction: (x: any): boolean => typeof x === 'function',
    isObject: (x: any): boolean => typeof x === 'object' && x !== null && !Array.isArray(x),
    isNumber: (x: any): boolean => typeof x === 'number' && !Number.isNaN(x),
    isInteger: (x: any): boolean => Number.isInteger(x),
    isArray: (x: any): boolean => Array.isArray(x),
    isBoolean: (x: string) => x.toLowerCase() === "true" || x.toLowerCase() === "false",
    isDateTime: (x: string) => Date.parse(x) > 0,
    isStringNumber,
};


export default typeHelper;
